import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ae6a13b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-start align-center" }
const _hoisted_2 = { class: "d-flex align-center" }
const _hoisted_3 = { class: "d-flex align-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = {
  class: "text-h6 text-grey-darken-1",
  style: {"font-weight":"400"}
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "actions d-flex align-center justify-end" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "appbar-filters",
  class: "mb-3"
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Ricarica", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "appbar-actions",
  class: "mr-3"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_base_applications = _resolveComponent("base-applications")!
  const _component_base_profiles = _resolveComponent("base-profiles")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_base_dialog = _resolveComponent("base-dialog")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!

  return (_openBlock(), _createBlock(_component_v_app_bar, {
    app: "",
    elevation: "0",
    height: "100",
    color: "grey-lighten-4"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_container, {
        fluid: "",
        class: "px-0"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { class: "px-2 pr-3" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                class: "py-0 d-flex justify-space-between align-center",
                cols: "12"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_v_img, {
                      src: _ctx.$env('VUE_APP_PRODUCT_LOGO_EXTENDED'),
                      width: "148",
                      height: "48",
                      class: "ml-2 mb-2",
                      contain: ""
                    }, null, 8, ["src"])
                  ]),
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_base_applications),
                    _createVNode(_component_base_profiles)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, { class: "mt-1" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { class: "d-flex justify-space-between align-center py-0" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    (!new RegExp('\/dashboard[\/(\w+)]*').test(_ctx.$route.fullPath))
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          icon: "",
                          onClick: _cache[0] || (_cache[0] = 
                () => {
                  if (!_ctx.isCreatingPage || !_ctx.communicationStore.isCreating) {
                    _ctx.onBack();
                  }
                }
              ),
                          key: "back",
                          color: "grey-lighten-4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, {
                              size: "28",
                              icon: "mdi:mdi-arrow-left",
                              color: "grey-darken-2"
                            }),
                            (_ctx.isCreatingPage && _ctx.communicationStore.isCreating)
                              ? (_openBlock(), _createBlock(_component_base_dialog, {
                                  key: 0,
                                  "onClick:confirm": _ctx.onBack
                                }, {
                                  title: _withCtx(() => [
                                    _createTextVNode("Attenzione!")
                                  ]),
                                  content: _withCtx(() => [
                                    _createTextVNode(" Non hai ancora salvato i dati, se decidi di continuare tutti i "),
                                    _hoisted_4,
                                    _createTextVNode(" dati modificati andranno persi. ")
                                  ]),
                                  _: 1
                                }, 8, ["onClick:confirm"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", {
                      class: _normalizeClass(["font-weight-medium text-grey-darken-2", [
                (_ctx.$vuetify.display.lgAndUp && !_ctx.$vuetify.display.xl) ||
                _ctx.$vuetify.display.lgAndDown ||
                _ctx.$vuetify.display.height < 800
                  ? 'text-h6'
                  : 'text-h5',
                new RegExp('\/dashboard[\/(\w+)]*').test(_ctx.$route.fullPath)
                  ? 'ml-4'
                  : '',
              ]]),
                      style: {"line-height":"unset"}
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.$route.meta.title) + " ", 1),
                      _createElementVNode("span", _hoisted_5, [
                        (_ctx.buildingStore.activeBuilding?.name)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_6, "/"))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(_ctx.buildingStore.activeBuilding?.name), 1)
                      ])
                    ], 2)
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createVNode(_component_v_tooltip, { bottom: "" }, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_btn, _mergeProps({ icon: "" }, props, {
                          id: "reload",
                          onClick: _cache[2] || (_cache[2] = 
                    () => {
                      if (!_ctx.isCreatingPage || !_ctx.communicationStore.isCreating) {
                        _ctx.$emit('refresh');
                      }
                    }
                  ),
                          class: ""
                        }), {
                          default: _withCtx(() => [
                            _createVNode(_component_v_avatar, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, { icon: "mdi:mdi-refresh" })
                              ]),
                              _: 1
                            }),
                            (_ctx.isCreatingPage && _ctx.communicationStore.isCreating)
                              ? (_openBlock(), _createBlock(_component_base_dialog, {
                                  key: 0,
                                  "onClick:confirm": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('refresh')))
                                }, {
                                  title: _withCtx(() => [
                                    _createTextVNode("Attenzione!")
                                  ]),
                                  content: _withCtx(() => [
                                    _createTextVNode(" Non hai ancora salvato i dati, se decidi di continuare tutti i "),
                                    _hoisted_9,
                                    _createTextVNode(" dati modificati andranno persi. ")
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1040)
                      ]),
                      default: _withCtx(() => [
                        _hoisted_10
                      ]),
                      _: 1
                    }),
                    _hoisted_11
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}